// Global search "Show All" for device searches with too many matches: opens the MSP device list
// with the search term in its search box (devicePage reads location.state.globalSearchText).

/** Global device search response code for "Too many results found. Refine your search." */
export const DEVICE_SEARCH_TOO_MANY_RESULTS_CODE = 60001;

/** MSP-level device list that "Show All" opens. */
export const SHOW_ALL_DEVICES_PATH = '/mspHome/devices';

/** True when a global device search response code means "too many results". */
export const isDeviceSearchTooManyResults = (responseCode) => Number(responseCode) === DEVICE_SEARCH_TOO_MANY_RESULTS_CODE;

/**
 * Router state for the device list: the trimmed search term, or null when there is none.
 * @param {string} query
 * @returns {{ globalSearchText: string } | null}
 */
export const getShowAllDevicesState = (query) => {
  const globalSearchText = typeof query === 'string' ? query.trim() : '';
  return globalSearchText ? { globalSearchText } : null;
};
